/**
 * @todo move into service
 */
export default {
    methods: {
        openStore($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const store = this.store;
            window.location.href = store.link;
        },

        fetchStore(storeId) {
            this.loading = true;

            axios.get('/api/stores/' + storeId)
                .then(response => {
                    this.store = response.data;
                })
                .catch(response => {})
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
